export const APP_NAME = 'GAA International';



// WEBPACK FOOTER //
// ./src/constants/resource.constants.js